import React from 'react'
import Widget from '../Widget/Widget'
import Table from '../Table/Table'

export const DetailCardWithTable = ({
  title,
  button,
  structure,
  data,
  statusComponent,
  onScrollAPI,
  dataTestId,
  subRowStructure,
  dropdownCallback,
  deleteMultipleScaleTickets,
  totalSelectedRow,
  productionPlanId,
  isLoadExtraData
}) => {
  return (
    <Widget title={title} button={button} totalSelectedRow={totalSelectedRow} productionPlanId={productionPlanId}>
      <div className="mb20 mt20">
        {data && (
          <Table
            dataTestId={dataTestId}
            structure={structure}
            subRowStructure={subRowStructure}
            data={data}
            isLoadExtraData={isLoadExtraData}
            statusComponent={statusComponent}
            onScrollAPI={onScrollAPI}
            dropdownCallback={dropdownCallback}
            deleteMultipleScaleTickets={deleteMultipleScaleTickets}
          />
        )}
      </div>
    </Widget>
  )
}

export default DetailCardWithTable
